import { Guardian } from "../types/athletes";

export function emailsEqual(a: string | undefined | null, b: string | undefined | null): boolean {
    const left = (a ?? "").trim().toLowerCase();
    const right = (b ?? "").trim().toLowerCase();
    return Boolean(left) && left === right;
}

/**
 * Resolve guardian 1 / guardian 2 emails from profile fields or the linked guardians list.
 */
export function resolveGuardianEmails(source: {
    parentEmail?: string | null;
    parentEmail2?: string | null;
    guardianEmail?: string | null;
    guardians?: Array<Pick<Guardian, "email"> | { email?: string } | null> | null;
}): { parentEmail: string; parentEmail2: string } {
    const fromGuardians = (source.guardians ?? [])
        .map((g) => (g?.email ?? "").trim())
        .filter((email) => email.length > 0);

    const parentEmail =
        (source.parentEmail ?? "").trim() ||
        (source.guardianEmail ?? "").trim() ||
        fromGuardians[0] ||
        "";

    const parentEmail2 =
        (source.parentEmail2 ?? "").trim() ||
        fromGuardians.find((email) => !emailsEqual(email, parentEmail)) ||
        "";

    return { parentEmail, parentEmail2 };
}
